(function($, document)   {
    "use strict";
    $(function()    {
        $(document).on('click', '.js-services-core > div', function()  {
            document.location.href = $(this).find('a').prop('href');
        });
        $('.services-other').hover(
            function()   {
                $(this).addClass('services-other-hover');
            },
            function()  {
                $(this).removeClass('services-other-hover');
            }
        );

        // $('.project').hover(
        //     function()   {
        //         $(this).addClass('project-hover');
        //     },
        //     function()  {
        //         $(this).removeClass('project-hover');
        //     }
        // );
        $('.services-related > div').hover(
            function()   {
                $(this).find('div.service').addClass('service-hover');
                var imageUrl = $(this).find('div.service').data('backgroundimage');
                $(this).find('div.service').css('backgroundImage', 'url(' + imageUrl + ')');
            },
            function()   {
                $(this).find('div.service').removeClass('service-hover');
                $(this).find('div.service').css('backgroundImage', '');
            }
        );

    });
})(jQuery, document);
